import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Package, List, X } from "@phosphor-icons/react";

const links = [
  { label: "Services", to: "/#services" },
  { label: "Track", to: "/track" },
  { label: "Get a Quote", to: "/#quote" },
  { label: "Branches", to: "/#branches" },
  { label: "Contact", to: "/#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(to);
    }
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-300 border-b ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-neutral-200 py-3" : "bg-transparent border-transparent py-5"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="bg-signal text-white p-1.5 group-hover:rotate-6 transition-transform duration-300">
            <Package weight="bold" size={22} />
          </span>
          <span className="font-display font-semibold text-xl tracking-tight text-obsidian">MAMA PARCEL</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => handleAnchor(l.to)}
              className="text-sm font-medium text-neutral-700 hover:text-signal transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/login"
            data-testid="admin-login-link"
            className="text-sm font-medium text-neutral-500 hover:text-obsidian transition-colors"
          >
            Admin
          </Link>
          <button
            data-testid="nav-book-btn"
            onClick={() => handleAnchor("/#quote")}
            className="bg-obsidian text-white text-sm font-medium px-5 py-2.5 hover:bg-signal transition-colors duration-200"
          >
            Ship Now
          </button>
        </div>

        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-obsidian"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-neutral-200 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => handleAnchor(l.to)}
              className="text-left text-base font-medium text-neutral-800"
            >
              {l.label}
            </button>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="text-left text-base font-medium text-neutral-500">
            Admin Login
          </Link>
        </div>
      )}
    </header>
  );
}
